import { render, staticRenderFns } from "./btnUpload.vue?vue&type=template&id=4824ed1a"
import script from "./btnUpload.vue?vue&type=script&lang=js"
export * from "./btnUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports